import { Component } from '@angular/core';
import { GetUserRequest as GetUserRequest } from './service/models/user.service.model';

@Component({
  selector: 'app-admin',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent {
  filter!: GetUserRequest;

  setFilter(filter: GetUserRequest) {
    this.filter = filter;
  }
}
